import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./EventMemberItem.module.css";

/**
 * A view component that displays information about an event member in the event members list.
 */

export function EventMemberItem({ eventMemberInfo }) {
  // set up default state
  const [_eventMemberInfo, setEventMemberInfo] = useState({
    iboNumber: "N/A",
    name: "N/A",
    tempAccount: null,
    dateAdded: "N/A",
    attended: null,
  });

  useMemo(() => {
    // null checking
    if (eventMemberInfo && eventMemberInfo !== null)
      setEventMemberInfo((prev) => ({
        iboNumber:
          eventMemberInfo.iboNumber && eventMemberInfo.iboNumber !== null
            ? eventMemberInfo.iboNumber
            : prev.iboNumber,
        name:
          eventMemberInfo.name && eventMemberInfo.name !== null
            ? eventMemberInfo.name
            : prev.name,
        tempAccount:
          eventMemberInfo.tempAccount !== undefined &&
          eventMemberInfo.tempAccount !== null
            ? eventMemberInfo.tempAccount
            : prev.tempAccount,
        dateAdded:
          eventMemberInfo.dateAdded && eventMemberInfo.dateAdded !== null
            ? eventMemberInfo.dateAdded
            : prev.dateAdded,
        attended:
          eventMemberInfo.attended !== undefined &&
          eventMemberInfo.attended !== null
            ? eventMemberInfo.attended
            : prev.attended,
      }));
  }, [eventMemberInfo]);

  return (
    <>
      <div className={styles.container}>
        <div>{_eventMemberInfo.iboNumber}</div>
        <div>{_eventMemberInfo.name}</div>
        <div>
          {_eventMemberInfo.tempAccount === null
            ? "N/A"
            : _eventMemberInfo.tempAccount
            ? "Yes"
            : "No"}
        </div>
        <div>{_eventMemberInfo.dateAdded}</div>
        <div>
          {_eventMemberInfo.attended === null
            ? "N/A"
            : _eventMemberInfo.attended
            ? "Yes"
            : "No"}
        </div>
      </div>
    </>
  );
}

EventMemberItem.propTypes = {
  // Object with the members info (jobCode- String, name- String, group- String, status-Bool)
  eventMemberInfo: PropTypes.shape({
    iboNumber: PropTypes.string,
    name: PropTypes.string,
    tempAccount: PropTypes.bool,
    dateAdded: PropTypes.string,
    attended: PropTypes.bool,
  }),
};
